import { useQuery } from "react-query";
import { getEntity } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useEntity = () => {
  return useQuery("GetEntity", getEntity, {
    refetchOnWindowFocus: false,
  });
};
